/* @flow */
/* eslint-env es6,browser */

import * as u from '../utils';
import adconfig from '../adconfig';
import * as jsonp from '../jsonp';
import adloader from '../adloader';
import { _openxad } from './openx';
import * as fetch from '../utils/fetch';

/**
 * Implements openx ad server functionality to fetch openx ads using jsonp API
 * @class
 * @exports adserver/openx2
 * @requires  module:utils
 * @requires  module:adconfig
 * @requires  module:jsonp
 * @requires  module:adloader
 * @requires  module:adserver/openx
 * @requires  module:utils/fetch
 */
class _openxad2 extends _openxad {
  constructor() {
    super();
    this._name = 'openx2';
  }

  _preloadJS() {
    /* dummy func to avoid preloading */
  }

  _loadAds(posList: Array<string>, resp: arjResponse, cVars: Object) {
    if (!(resp && resp.ads && u.isArray(resp.ads.ad))) {
      u.logError(
        `${this._name} ad request invalid response for ${posList.join(',')}`
      );
      return;
    }
    posList.forEach(pos => {
      let index = resp.ads.ad.findIndex(
        au => String(au.adunitid) === adconfig.getPosSettings(pos).auid
      );
      if (index >= 0 && resp.ads.ad[index].html) {
        resp.ads.ad[index].adunitid = -1;
        u.logDebug(
          `${this._name} : _loadAd : ${pos} ${resp.ads.ad[index].html}`
        );
        adloader.load(pos, resp.ads.ad[index].html, cVars[pos]);
      }
    });
  }

  _fetchAdsAsync(
    posList: Array<string>,
    cVars: Object,
    qParams: { [string]: any }
  ) {
    let auids = posList.map(pos => adconfig.getPosSettings(pos).auid),
      url = this._config.url + auids.join(','),
      params = {};
    qParams = qParams || {};
    params.data = {};
    params.logPrefix = posList.join(',');
    params.timeout = this._config.timeout;
    Object.keys(qParams).forEach(qp => (params.data[`c.${qp}`] = qParams[qp]));
    let callType = jsonp.JSONP;
    if (this._config.useFetch && fetch.isSupported()) {
      //Needed to avoid redirection in fetch call
      params.data.cc = 1;
      callType = fetch.JSON;
    }
    callType
      .call(this, url, params)
      .then(
        (resp: arjResponse) => this._loadAds(posList, resp, cVars),
        error => u.logError(`${this._name} ad request failure ${error || ''}`)
      );
  }

  /**
   * Loads openx static using adloader
   * @param {Array<string>} posList - position list array
   * @param {Object.<string, hbPosData>} o - header bidding return object
   * @param {Object} customVars - custom variable to be populated inside iframe
   * @returns {undefined}
   */
  loadAds(posList: Array<string>, o: hbPartnerData, customVars: Object) {
    posList = posList || {};
    posList.forEach(pos => {
      let cVars = {};
      cVars[pos] = this._getCustomVars(pos, o, customVars);
      this._fetchAdsAsync([pos], cVars, this._getQueryParams(pos, o));
    });
  }
}

let openx2 = new _openxad2();
export { openx2, _openxad2 };
